import styled from 'styled-components';
import { Link } from 'react-router-dom';

import {
  ScrollProps,
  scrollbarStyles,
} from '@web/components/ScrollableContainer/ScrollableContainer';

export const OuterWrapper = styled.div`
  background: rgba(0, 0, 0, 0.65);
  display: grid;
  inset: 0;
  place-items: center;
  position: fixed;
  z-index: 2000;
`;

export const InnerWrapper = styled.div`
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-flow: column;
  height: min(400px, 90vh);
  padding: 10px 0;
  width: min(400px, 90vw);
`;

export const Input = styled.input`
  border: 1px solid ${({ theme }) => `${theme.colors.iconGray}7A`};
  border-radius: 3px;
  margin: 0 10px 5px;
  padding: 5px 10px;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
    outline: 0;
  }
`;

export const List = styled.ol<ScrollProps>`
  flex: 1;
  list-style: none;
  margin: 0;
  overflow: auto;
  padding: 0 0 0 10px;

  ${scrollbarStyles}
  scrollbar-color: var(--scrollbarThumbHoverColor) var(--scrollbarThumbColor);

  &::-webkit-scrollbar-thumb {
    background-color: var(--scrollbarThumbColor);
  }
`;

type Props = {
  isSelected?: boolean;
};
export const ListItem = styled.li<Props>`
  border-radius: 3px;
  background-color: ${({ isSelected, theme }) =>
    isSelected ? `${theme.colors.iconGray}7A` : `${theme.colors.iconGray}19`};
  margin-bottom: 1px;
  padding: 5px 10px;
`;

export const ListItemLink = styled(Link)`
  color: inherit;
  display: block;
`;
